import { QueryClient } from '@tanstack/react-query';
import { ApiRequestError } from '../shared/api/client';

/**
 * Shared React Query client.
 *
 * Retry policy is the interesting part. A 4xx is a decision, not a glitch —
 * retrying a 403 or a 422 three times just multiplies the error toasts. Only
 * transport failures and 5xx are retried, and only twice.
 *
 * `refetchOnWindowFocus` is on because stock genuinely changes while a tab is
 * in the background: coming back to a stale balance is how a storekeeper
 * promises a customer an item that left the building an hour ago.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      retry: (failureCount, error) => {
        if (error instanceof ApiRequestError && error.status < 500) {
          return false;
        }
        return failureCount < 2;
      },
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
    },
    mutations: {
      // A mutation is a deliberate action; repeating it silently could post
      // the same document twice.
      retry: false,
    },
  },
});
